import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/App';
import { initLocale } from '@/locales/translate';
import { bootstrapSession } from '@/services/session';
import '@/styles/global.css';

initLocale();
void bootstrapSession();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
